<template>
<div>
  <div class="wistia_embed wistia_async_va3n7ceqac">
    &nbsp;
  </div>

  <div
    id="choose_administrator"
    class="tbk-vid-embed"
  >
    <a
      id="partnerships_cecilia"
      class="embedded_video"
      href="#wistia_k5vpz9d2lv?videoFoam=true"
    >
      &nbsp;
    </a>
    <br>

    <a
      id="partnerships_julia"
      class="embedded_video"
      href="#wistia_293qnkc1f9?videoFoam=true"
    >
      &nbsp;
    </a>
    <br>
  </div>
</div>
</template>

<script>
import TbkVideoMixin from './TbkVideoMixin'

export default {
  mixins: [TbkVideoMixin],

  mounted() {
    this.tbk.loadCrossTime('va3', 0, this.showSelect)

    this.tbk.loadCrossTime('k5v', 68, this.showSelect)
    this.tbk.loadCrossTime('293', 71, this.showSelect)

    if (this.tbk.isMobile()) {
      _wq.push({
        k5v: this.tbk.autoPlay,
        293: this.tbk.autoPlay
      })
    }
  },

  methods: {
    showSelect() {
      $('.tbk-vid-embed').show()
      this.tbk.hideMobileControls()
    }
  }
}
</script>

<style scoped lang="sass">
#choose_administrator
  display: none
  a
    text-decoration: none
#partnerships_cecilia
  position: absolute
  top: 0
  left: 0
  width: 50%
  height: 100%
#partnerships_julia
  position: absolute
  top: 0
  left: 50%
  width: 50%
  height: 100%
</style>
